import { NgModule }                            from '@angular/core';
import { Http, RequestOptions }                from '@angular/http';
import { ConfigService }                       from './configuracion/config.service';
import { RequestBaseService }                  from './request-base/request-base.service';
import { AuthGuardService }                    from './auth-guard/auth-guard.service';
import { CategoriaLicenciaService }            from './categoria-licencia/categoria-licencia.service';
import { CiudadService }                       from './ciudad/ciudad.service';
import { DepartamentoService }                 from './departamento/departamento.service';
import { MunicipioService }                    from './municipio/municipio.service';
import { ClaseVehiculoService }                from './clase-vehiculo/clase-vehiculo.service';
import { ConductorService }                    from './conductor/conductor.service';
import { PasajeroService }                     from './pasajero/pasajero.service';
import { PropietarioService }                  from './propietario/propietario.service';
import { EjecucionActividadService }           from './ejecucion-actividad/ejecucion-actividad.service';
import { RutaService }                         from './ruta/ruta.service';
import { TiqueteService }                      from './tiquete/tiquete.service';
import { TipoPropietarioService }              from './tipo-propietario/tipo-propietario.service';
import { UsuarioService }                      from './usuario/usuario.service';
import { VehiculoService }                     from './vehiculo/vehiculo.service';
import { ViajeService }                        from './viaje/viaje.service';
import { MaquinaService }                      from './maquina/maquina.service';
import { TipoMaquinaService }                  from './tipo-maquina/tipo-maquina.service';
import { SedeService }                         from './sede/sede.service';
import { ActividadService }                    from './actividad/actividad.service';
import { RepuestoService }                     from './repuesto/repuesto.service';
import { PeriodoEjecucionService }             from './periodo-ejecucion/periodo-ejecucion.service';
import { ManualFuncionamientoService }         from './manual-funcionamiento/manual-funcionamiento.service';
import { CertificadoFuncionamientoService }    from './certificado-funcionamiento/certificado-funcionamiento.service';
import { ProcesoActividadService }             from './proceso-actividad/proceso-actividad.service';
import { InformeMantenimientoService }         from './informe-mantenimiento/informe-mantenimiento.service';

import { CategoriasService }                   from './categorias/categorias.service';
import { ClasificadosService }                 from './clasificados/clasificados.service';
import { ColoresService }                      from './colores/colores.service';
import { SubCategoriasService }                from './subcategorias/subcategorias.service';
import { OperacionesService }                  from './operaciones/operaciones.service';
import { NoticiasService }                     from './noticias/noticias.service';
import { TarifasService }                      from './tarifas/tarifas.service';

@NgModule({
  providers: [
    CategoriasService,
    ClasificadosService,
    ColoresService,
    NoticiasService,
    OperacionesService,
    SubCategoriasService,
    TarifasService,

    AuthGuardService,
    CategoriaLicenciaService,
    CiudadService,
    ClaseVehiculoService,
    ConductorService,
    ConfigService,
    DepartamentoService,
    MunicipioService,
    MaquinaService,
    PasajeroService,
    PropietarioService,
    RequestBaseService,
    RutaService,
    TipoPropietarioService,
    TiqueteService,
    TipoMaquinaService,
    SedeService,
    ActividadService,
    RepuestoService,
    UsuarioService,
    VehiculoService,
    PeriodoEjecucionService,
    EjecucionActividadService,
    ManualFuncionamientoService,
    CertificadoFuncionamientoService,
    InformeMantenimientoService,
    ProcesoActividadService,
    ViajeService
  ]
})
export class ServicesModule {
  constructor() { }
}



// WEBPACK FOOTER //
// ./src/app/services/services.module.ts